import React, { Fragment } from "react";
import Navbar from "../../components/Navbar/Navbar";
import PageTitle from "../../components/pagetitle/PageTitle";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Footer from "../../components/footer/Footer";

const TermsAndConditions = () => {
  return (
    <Fragment>
      <Navbar />
      <PageTitle
        pageTitle={"Terms and Conditions"}
        pagesub={"Terms and Conditions"}
      />
      <div className="container policy" style={{ marginTop: 50 }}>
        <section className="mb-6">
          <h2 className="mb-2 policy-title">Your Personal Information</h2>
          <p>
            At <strong>Chemist For All</strong>, we are committed to
            safeguarding your privacy. Any personal information you share with
            us—such as your name, address, email, phone number, and payment
            details—is collected solely to process your orders, ensure secure
            transactions, and improve your shopping experience.
          </p>
          <p className="mt-2">
            We do not sell, rent, or share your personal information with any
            third party, except when required by law or with your explicit
            consent. Your data is stored on secure servers, and we take all
            reasonable steps to protect it from unauthorized access, misuse, or
            disclosure.
          </p>
        </section>

        <section className="mb-6">
          <h2 className="mb-2 policy-title">Security of Transactions</h2>
          <p>
            All transactions made through our website are protected with SSL
            (Secure Socket Layer) encryption, ensuring that your sensitive data
            (such as payment details) is transmitted safely over the internet.
            We partner with secure and reputable payment gateways, and no
            payment information is stored directly on our servers.
          </p>
          <p className="mt-2">
            We also offer e-check payments, which are processed through secure
            and compliant systems to maintain the highest level of financial
            privacy.
          </p>
        </section>

        <section className="mb-6">
          <h2 className="mb-2 policy-title">Prescription Policy</h2>
          <p>
            Chemist For All complies with U.S. laws and regulations. A valid
            prescription is required for all prescription medications. Customers
            may upload the prescription during the checkout process or may
            simply mail us. For OTC (over-the-counter) products, no prescription
            is required.
          </p>
        </section>

        <section className="mb-6">
          <h2 className="mb-2 policy-title">Drug Disclaimer</h2>
          <p>
            The medicines available on our website are generic alternatives that
            contain the same active ingredients as brand-name drugs. Any
            reference to a brand-name product is strictly for informational
            purposes to help you understand the therapeutic equivalence of our
            offerings.
          </p>
          <p className="mt-2">
            Chemist For All is not affiliated with any brand-name manufacturers,
            nor do we claim to sell their products. We do not use their
            trademarks to promote or misrepresent our services. The use of such
            names is only to aid customer awareness and does not indicate any
            partnership, endorsement, or association.
          </p>
        </section>

        <section className="mb-6">
          <h2 className="mb-2 policy-title">Shipping Policy</h2>
          <p>
            We offer nationwide delivery across the United States, Australia,
            and the United Kingdom. Once your prescription is verified and
            payment is confirmed, your order will be processed and shipped
            within 2–3 business days. The estimated delivery timeline is 15–20
            days from the date of shipping.
          </p>
          <p className="mt-2">
            Shipping fees are calculated based on the weight and contents of
            your order. In some cases, delivery may be delayed due to customs
            inspections, local postal regulations, or other external factors.
          </p>
          <p className="mt-2">
            You can update your shipping address anytime in your account
            settings. Changes made after placing an order will not affect that
            particular shipment.
          </p>
        </section>

        <section className="mb-6">
          <h2 className="mb-2 policy-title">Pricing and Shipping Charges</h2>
          <p>
            All product prices and shipping fees listed on our website are
            subject to change without prior notice. Prices may vary based on
            availability, manufacturer costs, and shipping rates.
          </p>
          <p className="mt-2">
            If the price of a product or shipping charge changes after your
            order is placed, we will notify you before processing. We do not
            charge you more than what is shown at the time of your confirmed
            order unless you approve the change.
          </p>
        </section>

        <section className="mb-6">
          <h2 className="mb-2 policy-title">
            Refunds, Cancellations & Returns
          </h2>
          <p>
            Due to the nature of pharmaceutical products, returns and exchanges
            are not accepted once the order is shipped. However, if you receive
            a damaged, incorrect, or incomplete order, please contact us at{" "}
            <a
              className="text-blue-600"
              href="mailto:support@chemistforall.com"
            >
              support@chemistforall.com
            </a>{" "}
            within 48 hours of delivery.
          </p>
          <p className="mt-2">
            We will review your issue and provide a resolution, which may
            include a partial refund, reshipment, or store credit. Cancellations
            can only be made before the order is processed and shipped.
          </p>
        </section>

        <section className="mb-6">
          <h2 className="mb-2 policy-title">Prohibited Substances</h2>
          <p>
            Chemist For All does not sell or ship controlled substances,
            narcotics, or any medications classified under restricted
            categories, including but not limited to benzodiazepines or opioids.
            We reserve the right to reject orders that do not comply with our
            internal guidelines or legal obligations.
          </p>
        </section>

        <section>
          <h2 className="mb-2 policy-title">User Consent</h2>
          <p>
            By using our website, you agree to the terms stated above. We
            reserve the right to update our policies and terms at any time. Any
            changes will be posted on this page for full transparency. Continued
            use of our website after such changes implies acceptance.
          </p>
        </section>
      </div>
      <Footer />
      <Scrollbar />
    </Fragment>
  );
};

export default TermsAndConditions;
